import React from 'react'

const MyTasksSkeleton = () => {
    return (
        <div className="my-tasks-widget relative xxs:w-full xl:w-[480px] flex justify-center h-full">
            <div className="bg-white h-full rounded-xl w-full flex flex-col">
                {/* Tasks navigation section */}
                <div className="flex items-center mt-5 mx-[35px]">
                    <div className="font-bold text-[20px] mr-[5px] text-darkPurple animate-pulse">
                        <div className="h-6 bg-lightBG rounded w-[100px] opacity-50"></div>
                    </div>
                    <div className="flex-1"></div>
                    <div className="w-[20px] h-[20px] bg-lightBG rounded opacity-50"></div>
                    <div className="ml-[10px] font-bold text-[16px] text-mudPurple animate-pulse">
                        <div className="h-5 bg-lightBG rounded w-[56px] opacity-50"></div>
                    </div>
                </div>

                {/* Title section */}
                <div className="mt-[10px] mx-[35px]">
                    <div className="h-4 bg-lightBG rounded w-[180px] opacity-50"></div>
                </div>

                {/* Divider */}
                <div className="mt-5 mx-[35px] h-[1px] border-b border-dashed border-b-lightBG"></div>

                {/* Tasks content section */}
                <div className="flex flex-col flex-auto mx-[10px] bg-white mt-4">
                    {/* Task items */}
                    {[...Array(3)].map((_, index) => (
                        <div key={index} className="flex flex-col p-6 border-b border-lightBG animate-pulse">
                            <div className="flex justify-between items-center mb-2">
                                <div className="h-5 bg-lightBG rounded w-[60%] opacity-50"></div>
                                <div className="w-[80px] h-[25px] bg-lightBG rounded-full opacity-50"></div>
                            </div>
                            <div className="h-4 bg-lightBG rounded w-[40%] opacity-30 mb-4"></div>
                            <div className="flex gap-2 items-center">
                                <div className="w-[30px] h-[30px] rounded-full bg-lightBG opacity-50"></div>
                                <div className="h-4 bg-lightBG rounded w-[120px] opacity-30"></div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>

            {/* Expand/collapse button */}
            <div className="rounded-full absolute -bottom-[20px] w-[40px] h-[40px] bg-white border border-lightBG flex items-center justify-center">
                <div className="w-[15px] h-[15px] bg-deepPurple opacity-50 rounded"></div>
            </div>
        </div>
    )
}

export default MyTasksSkeleton
